var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabletIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M411.46,29.23c13.16,2.41,25.19,14.03,25.19,27.54l.07,397.13c0,14.6-11.48,26.93-25.26,28.87H100.1c-12.89-2.21-24.8-13.92-24.8-27.97l.02-397.58c0-14.66,12.21-25.57,25.66-28h310.48ZM428.43,453.42l.03-394.44c0-10.68-8.44-21.44-19.71-21.44l-305.04-.03c-10.77,0-20.15,9.94-20.15,20.59v396.23c0,10.07,9.5,20.27,20.46,20.28l302.48.06c6.15,0,11.31-1.86,15.57-6.11,4.06-4.05,6.37-9.1,6.37-15.12ZM256,439.59c-8.13,0-14.72,6.59-14.72,14.72s6.59,14.72,14.72,14.72,14.72-6.59,14.72-14.72-6.59-14.72-14.72-14.72ZM256.01,49.14c-4.75,0-8.61,3.85-8.61,8.61s3.85,8.61,8.61,8.61,8.61-3.85,8.61-8.61-3.85-8.61-8.61-8.61Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M408.2,433.96H103.9c-2.24-.45-4.32-1.82-4.32-4.36V82.13c0-2.74,2.63-4.09,5.05-4.09l303.58.02c1.92,0,4.2,1.67,4.2,3.64v348.32c-.55,2.18-1.75,3.37-4.21,3.93ZM107.89,85.48v340.13s296.23,0,296.23,0V85.47s-296.23,0-296.23,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletIcon);
export default __webpack_public_path__ + "static/media/tabletIcon.c900c9ba477512048cbe9b2ba7849e3e.svg";
export { ForwardRef as ReactComponent };